import { useEffect } from 'react';

/**
 * Hook para fazer scroll suave para o topo da página
 * @param dependency - Dependência opcional que dispara o scroll quando muda
 */
export const useScrollToTop = (dependency?: any) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, dependency ? [dependency] : []);
};

export default useScrollToTop; 
